import api from "../../../services/api.service"

/**
 * The backend answers errors as {status:false, message:"..."} with HTTP 400,
 * so the useful text is response.data.message — error.message is only axios'
 * generic "Request failed with status code 400".
 */
function errorMessage(error) {
    if (error == null) return 'Unknown error';
    if (typeof error === 'string') return error;
    const data = error.response && error.response.data;
    if (data && typeof data.message === 'string' && data.message.trim() !== '') return data.message;
    if (typeof error.message === 'string') return error.message;
    return String(error);
}


export const whatsappModule = {
    namespaced: true,
    state: {},
    getters: {
        canReadWhatsapp(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('whatsapp');
        },
        canEditWhatsapp(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('whatsapp');
        },
    },
    mutations: {},
    actions: {
        getData() {
            return new Promise(function (resolve) {

                resolve();

            })
        },

        getAllMessages(actions) {

            return new Promise(function (resolve, reject) {
                api.sendRequest('whatsapp/unseen',{
                    buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),

                }).then(
                    (ans) => {
                        if (ans["messages"] == null)
                            return reject('Could not get Messages ');

                        resolve(ans);
                    }, (error) => {

                        reject(error.message)
                    })
            })

        },
        getMessagesByClientId(actions, clientId) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('whatsapp/id/' + clientId).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {

                        reject(error.message)
                    })
            })
        },
        sendWhatsappMessage(actions, { newMessage, template }) {
            console.log("sendWhatsappMessage", newMessage);

            // Build WAMessageRequest payload
            const payload = {
                body: newMessage.body || '',
                clientId: newMessage.clientId,
                isTemplate: !!template,
                // Only include template fields when sending a template
                ...(template ? {
                    templateName: newMessage.templateName,
                    templateLanguage: newMessage.templateLanguage || 'en',
                } : {})
            };

            // If your backend maps boolean getters differently, uncomment:
            // payload.template = payload.isTemplate;

            return new Promise(function (resolve, reject) {
                api.sendRequest('whatsapp/send/' + (!!template), null, payload).then(
                    (ans) => {
                        if (ans["messages"] == null)
                            return reject('Could not send message ');
                        actions.dispatch('notifications/success',
                            {
                                title: { text: 'Whatsapp' },
                                message: { text: '%s sent successfully', arguments: ['Message'] }
                            },
                            { root: true });
                        resolve(ans);
                    },
                    (error) => {
                        actions.dispatch('notifications/error',
                            {
                                title: { text: 'Whatsapp ' },
                                message: errorMessage(error)
                            },
                            { root: true });
                        reject(errorMessage(error));
                    }
                )
            })
        },

        getWhatsappTemplates(actions,{clientId}) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('whatsapp/templates/'+clientId, null, null).then(
                    (ans) => {
                        // Ensure data array exists

                        if (ans["response"] == null)
                            return reject("No WhatsApp templates were returned for this branch");
                        resolve(ans);
                    }, (error) => {
                        actions.dispatch('notifications/error',
                            {
                                title: { text: 'Whatsapp Templates' },
                                message: errorMessage(error)
                            },
                            { root: true });
                        reject(errorMessage(error));
                    });
            });
        },   getWhatsappTemplatesByBranch(actions,{branchId}) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('whatsapp/templatesByBranch/'+branchId, null, null).then(
                    (ans) => {
                        // Ensure data array exists

                        if (ans["response"] == null)
                            return reject("No WhatsApp templates were returned for this branch");
                        resolve(ans);
                    }, (error) => {
                        actions.dispatch('notifications/error',
                            {
                                title: { text: 'Whatsapp Templates' },
                                message: errorMessage(error)
                            },
                            { root: true });
                        reject(errorMessage(error));
                    });
            });
        },
        getWhatsappList() {

            return new Promise(function (resolve, reject) {
                api.sendRequest('whatsapp/getWhatsappList', null, null).then(
                    (ans) => {
                        if (ans["Whatsapps"] == null)
                            return reject('Could not get whatsapps ');

                        resolve(ans["Whatsapps"]);
                    }, (error) => {

                        reject(error.message)
                    })
            })

        },

        getWhatsappById(actions, id) {
            return new Promise((resolve, reject) => {

                api.sendRequest('whatsapp/id/' + id, {}).then(
                    (ans) => {

                        if (ans["whatsapp"] == null)
                            return reject('Could not get whatsapp ');

                        resolve(ans["whatsapp"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        updateWhatsapp(actions, whatsapp) {
            return new Promise((resolve, reject) => {

                api.sendRequest('whatsapp/update', null, whatsapp).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Update whatsapp', message: 'Whatsapp updated successfully'},
                            {root: true});

                        if (ans["whatsappId"] == null)
                            return reject('Could not update whatsapp ');

                        resolve(ans["whatsappId"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        createWhatsapp(actions, whatsapp) {
            return new Promise((resolve, reject) => {


                api.sendRequest('whatsapp/add', null, whatsapp).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Add whatsapp', message: 'Whatsapp added successfully'},
                            {root: true});

                        if (ans["whatsappId"] == null)
                            return reject('Could not create whatsapp ');

                        resolve(ans["whatsappId"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

    },
};
